import { RootState } from 'reduxStore/types';

export const getSubcontractorModerationFormStatus = (state: RootState) =>
  state?.subcontractorModerationRequest.isFormDisabled;
